import "@expo/metro-runtime";
import { Platform } from "react-native";
// aaa_init is intended to be sorted at the top
import "./aaa_init";
import "react-native-reanimated";
import { registerRootComponent } from "expo";
import { activateKeepAwakeAsync } from "expo-keep-awake";
import "expo-asset";
import * as SplashScreen from "expo-splash-screen";
// initialize logging modules
import "./log";
import "../sentry";
import * as Sentry from "@sentry/react-native";
import { configureReanimatedLogger, ReanimatedLogLevel } from "react-native-reanimated";
import loadingPromise from "./mountApp.platform";
export * from "../types/global";
configureReanimatedLogger({
    level: ReanimatedLogLevel.warn,
    strict: false
});
if (__DEV__ && Platform.OS !== 'web') {
    void activateKeepAwakeAsync();
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mountApp(app) {
    if (Platform.OS !== 'web') {
        SplashScreen.setOptions({
            fade: true
        });
        SplashScreen.preventAutoHideAsync().catch(function() {
        // noop, prevent unused warning about splash already hidden
        });
    }
    loadingPromise.then(function() {
        var App = Sentry.wrap(app);
        registerRootComponent(App);
    }).catch(function(e) {
        Sentry.captureException(e);
        throw e;
    });
}
